export default __webpack_public_path__ + "static/media/96tmxeth.f8f45f53.png";